<template>
    <div class="stepper flex flex-wrap justify-between relative">
        <div class="stepper-progress h-1 bg-leonard-green absolute left-0 top-3 transition-all ease-in-out duration-500" :style="'width: ' + stepProgress + '%'"></div>
        <div class="step" :class="{'text-leonard-white': isCompleted(num), 'text-leonard-green': isCurrentStep(num), 'cursor-not-allowed text-leonard-grey-disabled': isDisabled(num), 'cursor-pointer': !isDisabled(num)}" v-for="num in numSteps" :key="num" @click="changeStep(num)">
            <div class="step-details bg-leonard-white px-2 block relative z-[2]">
                <div :class="{'border-leonard-green': isCurrentStep(num), 'bg-leonard-green border-leonard-green': isCompleted(num), ' bg-leonard-white border-leonard-grey-disabled': isDisabled(num), 'border-gray-900': !isCompleted(num) && !isDisabled(999)}" class="border w-7 h-7 text-center pt-0.5 mx-auto rounded-full">
                    <font-awesome-icon icon="check" v-if="isCompleted(num)"></font-awesome-icon>
                    <span v-else>{{num}}</span>
                </div>
                <div class="text-nowrap mt-2 text-center text-sm" :class="{'text-leonard-green': isCurrentStep(num) || isCompleted(num), 'text-leonard-grey-disabled': isDisabled(num)}">
                    {{Object.keys(stepLabels[num-1])[0] || 'Step ' + num}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faCheck } from '@fortawesome/free-solid-svg-icons';

    export default {
        props: ['numSteps', 'stepLabels', 'currentStep'],

        data() {
            return {
                progress: [
                    true,
                    false,
                    false,
                    false,
                    false
                ]
            }
        },

        created() {
            library.add(faCheck);

            if(this.$route.params.step && localStorage.getItem('access_code')) {
                this.updateProgress();
            }
        },

        mounted() {
            window.events.$on('updateProgress', this.updateProgress);
        },

        beforeDestroy() {
            window.events.$off('updateProgress');
        },

        methods: {
            changeStep(num) {
                if(this.progress[num - 1]) {
                    const slug = Object.values(this.stepLabels[num-1])[0].slug;
                    if(slug !== this.$route.params.step) {
                        this.progress.map((val, i) => {
                            this.progress[i] = i < num;
                        })
                        this.$emit('goToStep', slug);
                    }
                }
            },

            updateProgress() {
                this.stepLabels.forEach(el => {
                    const page = Object.values(el)[0];
                    if(page.slug === this.currentStep) {
                        this.progress.forEach((p, j) => {
                            this.progress[j] = j < page.id
                        })
                    }
                });
            },

            isCurrentStep(num) {
                const slug = Object.values(this.stepLabels[num-1])[0].slug;
                return this.currentStep === slug;
            },

            isCompleted(num) {
                return this.progress[num];
            },

            isDisabled(num) {
                return !this.progress[num - 1];
            }
        },

        computed: {
            stepProgress() {
                const section = 100 / (this.numSteps - 1);
                const step = this.stepLabels.find(o => Object.values(o)[0].slug === this.currentStep);

                if (step) {
                    const stepId = Object.values(step)[0].id;
                    return stepId === 1 ? 0 : section * (stepId - 1);
                }

                return 0;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .stepper-progress {
        z-index: 1;
        width: 0;
    }
</style>
